/* eslint-disable */
// 刮刮樂套件js https://github.com/artwl/Lottery
// 調整為class寫法

// 刮刮樂物件，constructor指定
var scratchOffObj = null;

export class ScratchOff {
  constructor(id, cover, coverType, width, height, drawPercentCallback) {
    this.conId = id;
    this.conNode = document.getElementById(this.conId);
    this.cover = cover;
    this.coverType = coverType;
    this.background = null;
    this.backCtx = null;
    this.mask = null;
    this.maskCtx = null;
    this.lottery = null;
    this.lotteryType = 'image';
    this.width = width || 300;
    this.height = height || 100;
    this.clientRect = null;
    this.drawPercentCallback = drawPercentCallback;
    this.isMouseDown = false;
    scratchOffObj = this;
    // 是否初始化完成
    this.initialComplete = {
      // 背景
      background: false,
      // 遮罩
      mask: false,
      // 設定
      set(id) {
        this[id] = true;
        if (this.background && this.mask) scratchOffObj.showLottery();
      }
    };
  }
  createElement(tagName, attributes) {
    const ele = document.createElement(tagName);
    for (const key in attributes) {
      ele.setAttribute(key, attributes[key]);
    }
    return ele;
  }
  getTransparentPercent(ctx, width, height) {
    const imgData = ctx.getImageData(0, 0, width, height);
    const pixles = imgData.data;
    const transPixs = [];
    for (let i = 0, j = pixles.length; i < j; i += 4) {
      const a = pixles[i + 3];
      if (a < 128) {
        transPixs.push(i);
      }
    }
    return (transPixs.length / (pixles.length / 4) * 100).toFixed(2);
  }
  resizeCanvas(canvas, width, height) {
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').clearRect(0, 0, width, height);
  }
  drawPoint(x, y) {
    this.maskCtx.beginPath();
    const radgrad = this.maskCtx.createRadialGradient(x, y, 0, x, y, 30);
    radgrad.addColorStop(0, 'rgba(0,0,0,0.6)');
    radgrad.addColorStop(1, 'rgba(255, 255, 255, 0)');
    this.maskCtx.fillStyle = radgrad;
    this.maskCtx.arc(x, y, 30, 0, Math.PI * 2, true);
    this.maskCtx.fill();    
    if (this.drawPercentCallback) {
      this.drawPercentCallback.call(null, this.getTransparentPercent(this.maskCtx, this.width, this.height));
    }
  }
  bindEvent() {
    const _this = this;
    const device = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    const clickEvtName = device ? 'touchstart' : 'mousedown';
    const moveEvtName = device ? 'touchmove' : 'mousemove';
    if (!device) {
      document.addEventListener('mouseup', _this.stopDown, { passive: false });
    } else {
      document.addEventListener('touchmove', _this.preventMove, { passive: false });
      document.addEventListener('touchend', _this.stopDown, { passive: false });
    }
    this.mask.addEventListener(clickEvtName, _this.clickOnMask, { passive: false });

    this.mask.addEventListener(moveEvtName, _this.moveOnClick, { passive: false });
  }
  drawLottery() {
    // 先暫時隱藏等初始完成再顯示，visibility: hidden;
    this.background = this.background || this.createElement('canvas', {
      style: 'width:100%;visibility: hidden;',
    });

    // 先暫時隱藏等初始完成再顯示，visibility: hidden;
    this.mask = this.mask || this.createElement('canvas', {
      style: 'position:absolute;left:0;top:0;width:100%;visibility: hidden;',
      id: 'mask'
    });

    if (!this.conNode.innerHTML.replace(/[\w\W]| /g, '')) {
      this.conNode.appendChild(this.background);
      this.conNode.appendChild(this.mask);
      this.clientRect = this.conNode ? this.conNode.getBoundingClientRect() : null;
      this.bindEvent();
    }

    this.backCtx = this.backCtx || this.background.getContext('2d');
    this.maskCtx = this.maskCtx || this.mask.getContext('2d');

    if (this.lotteryType == 'image') {
      const image = new Image();
      const _this = this;
      image.onload = function () {
        // 不因圖片長寬調整
        // _this.width = this.width;
        // _this.height = this.height;
        _this.resizeCanvas(_this.background, _this.width, _this.height);
        _this.backCtx.drawImage(this, 0, 0);
        _this.drawMask();

        // 背景初始化完成
        _this.initialComplete.set('background');
      };
      image.src = this.lottery;
    } else if (this.lotteryType == 'text') {
      this.width = this.width;
      this.height = this.height;
      this.resizeCanvas(this.background, this.width, this.height);
      this.backCtx.save();
      this.backCtx.fillStyle = '#FFF';
      this.backCtx.fillRect(0, 0, this.width, this.height);
      this.backCtx.restore();
      this.backCtx.save();
      const fontSize = 30;
      this.backCtx.font = `Bold ${fontSize}px Arial`;
      this.backCtx.textAlign = 'center';
      this.backCtx.fillStyle = '#F60';
      this.backCtx.fillText(this.lottery, this.width / 2, this.height / 2 + fontSize / 2);
      this.backCtx.restore();
      this.drawMask();

      // 背景初始化完成
      this.initialComplete.set('background');
    }
  }
  drawMask() {
    this.resizeCanvas(this.mask, this.width, this.height);
    if (this.coverType == 'color') {
      this.maskCtx.fillStyle = this.cover;
      this.maskCtx.fillRect(0, 0, this.width, this.height);
      this.maskCtx.globalCompositeOperation = 'destination-out';
      // 遮罩初始化完成
      this.initialComplete.set('mask');
    } else if (this.coverType == 'image') {
      const image = new Image();
      image.crossOrigin = 'Anonymous';
      const _this = this;
      image.onload = function () {
        _this.maskCtx.drawImage(this, 0, 0);
        _this.maskCtx.globalCompositeOperation = 'destination-out';
        // 遮罩初始化完成
        _this.initialComplete.set('mask');
      };
      image.src = this.cover;
    }
  }
  init(lottery, lotteryType) {
    this.lottery = lottery;
    this.lotteryType = lotteryType || 'image';
    this.drawLottery();
  }
  // 顯示刮刮樂，等背景及遮罩完成才顯示
  showLottery(){
    this.mask.style.visibility = null;
    this.background.style.visibility = null;
  }
  // 停止觸碰事件(mouseup, touchend)
  stopDown() {
    scratchOffObj.isMouseDown = false;
  }
  // 取消移動中的預設事件(touchmove)
  preventMove(e) {
    if (scratchOffObj.isMouseDown) {
      e.preventDefault();
    }
  }
  // 遮罩上的點擊事件 (touchstart, mousedown)
  clickOnMask(e) {
    const _this = scratchOffObj;
    const device = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    _this.isMouseDown = true;
    const docEle = document.documentElement;
    if (!_this.clientRect) {
      _this.clientRect = {
        left: 0,
        top: 0,
      };
    }    
    const x = (device ? e.touches[0].clientX : e.clientX) - _this.clientRect.left + docEle.scrollLeft - docEle.clientLeft;
    const y = (device ? e.touches[0].clientY : e.clientY) - _this.clientRect.top + docEle.scrollTop - docEle.clientTop;
    _this.drawPoint(x, y); 
    
  }
  // 遮罩上的移動事件(touchmove, mousemove)
  moveOnClick(e) {
    const _this = scratchOffObj;
    const device = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    if (!device && !_this.isMouseDown) {
      return false;
    }
    const docEle = document.documentElement;
    if (!_this.clientRect) {
      _this.clientRect = {
        left: 0,
        top: 0,
      };
    }
    const x = (device ? e.touches[0].clientX : e.clientX) - _this.clientRect.left + docEle.scrollLeft - docEle.clientLeft;
    const y = (device ? e.touches[0].clientY : e.clientY) - _this.clientRect.top + docEle.scrollTop - docEle.clientTop;
    _this.drawPoint(x, y);
  }
  // 移除 listener
  removeListener() {
    const device = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));
    const clickEvtName = device ? 'touchstart' : 'mousedown';
    const moveEvtName = device ? 'touchmove' : 'mousemove';
    if (!device) {
      document.removeEventListener('mouseup', this.stopDown, { passive: false });
    } else {
      document.removeEventListener('touchmove', this.preventMove, { passive: false });
      document.removeEventListener('touchend', this.stopDown, { passive: false });
    }

    this.mask.removeEventListener(clickEvtName, this.clickOnMask, { passive: false });
    this.mask.removeEventListener(moveEvtName, this.moveOnClick, { passive: false });
  }
}


